module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/np-f7885aa646996a2aa6e0da751dd93816.svg";